import { Controller } from "@hotwired/stimulus"
import { get, post, put, patch, destroy } from "@rails/request.js"

// Connects to data-controller="report"
export default class extends Controller {
	static targets = ["kapitelFormular"]
	connect() {}

	kapitelFormularTargetConnected() {
		this.updateKapitelreihenfolge()
	}

	kapitelFormularTargetDisconnected() {
		this.updateKapitelreihenfolge()
	}

	// Setzt die aktuelle Kapitelreihenfolge in das hidden_field + update
	updateKapitelreihenfolge() {
		this.kapitelFormularTargets.forEach((kapitelForm, index) => {
			const positionField = kapitelForm.querySelector(".position_field")
			const newKapitelPosition = index + 1
			// Wenn im Hidden-Field nicht die neue/richtige Position steht:
			// -> Setze die neue Position ins Hidden-Field + sende update
			if (positionField.value != newKapitelPosition) {
				positionField.value = newKapitelPosition
    			this.sendRequest(kapitelForm.action, new FormData(kapitelForm));
			}
		})
	}

	sendRequest(url, formData) {
    	patch(url, { responseKind: "turbo-stream", body: formData })
 	}
}